var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 7.28571C5.0625 6.49674 5.67811 5.85714 6.4375 5.85714L10.5625 5.85714C11.3219 5.85714 11.9375 6.49674 11.9375 7.28571L11.9375 11.5714C11.9375 12.3604 11.3219 13 10.5625 13L6.4375 13C5.67811 13 5.0625 12.3604 5.0625 11.5714L5.0625 7.28571Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6875 3C2.92811 3 2.3125 3.63959 2.3125 4.42857L2.3125 8.71429C2.3125 9.50326 2.92811 10.1429 3.6875 10.1429L3.6875 4.42857L9.1875 4.42857C9.1875 3.63959 8.57189 3 7.8125 3L3.6875 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.c0b07489efb935d4d0e3ec670f0a0937.svg";
export { ForwardRef as ReactComponent };